<template>
  <div class="cell" @click="onClick">
    <div class="cell-hd">
      <slot name="icon"></slot>
    </div>
    <div class="cell-bd">
      <slot name="title">{{title}}</slot>
    </div>
    <div class="cell-ft" :class="valueClass">
      <slot name="value">{{value}}</slot>
    </div>
  </div>
</template>

<script>
  import props from './props'
  import {go} from '../../assets/js/lib/router'

  export default {
    name: "cell",
    computed: {
      valueClass () {
        return {
          'cell-ft__link': this.arrowDirection === 'right',
          'cell-arrow-up': this.arrowDirection === 'up',
          'cell-arrow-down': this.arrowDirection === 'down'
        }
      }
    },
    methods: {
      onClick: function () {
        this.isLink && go(this.link, this.$router)
      }
    },
    props: props()
  }
</script>

<style scoped>
  .cell {
    padding: 10px 15px;
    position: relative;
    display: -webkit-box;
    display: -webkit-flex;
    display: flex;
    -webkit-box-align: center;
    -webkit-align-items: center;
    align-items: center;
    outline: 0;
    border-bottom: 1px solid #eeeeee;
  }
  .cell:first-child {
    border: 0;
  }
  .cell-bd {
    -webkit-box-flex: 1;
    -webkit-flex: 1;
    flex: 1;
  }
  .cell-ft {
    text-align: right;
    color: #999;
  }
  .cell .cell-ft__link:after {
    content: " ";
    display: inline-block;
    height: 6px;
    width: 6px;
    border-width: 2px 2px 0 0;
    border-color: #c8c8cd;
    border-style: solid;
    -webkit-transform: matrix(.71,.71,-.71,.71,0,0);
    transform: matrix(.71,.71,-.71,.71,0,0);
    position: relative;
    top: -2px;
    position: absolute;
    top: 50%;
    margin-top: -4px;
    right: 2px;
  }
  .cell .cell-ft.cell-arrow-down:after {
    -webkit-transform: matrix(.71,.71,-.71,.71,0,0) rotate(90deg);
    transform: matrix(.71,.71,-.71,.71,0,0) rotate(90deg);
  }
  .cell .cell-ft.cell-arrow-up:after{
    transform: matrix(0.71, 0.71, -0.71, 0.71, 0, 0) rotate(-90deg);
  }
</style>



// WEBPACK FOOTER //
// components/cell/index.vue